import React, { useEffect, useState } from "react";
import styles from "../../styles/scope3/Dashboard/transportation.module.css";
import { monthlist } from "../../utils/constant";
import { useUser } from "../../context/AuthContext";
import { get } from "../../utils/api";
import { Checkbox, ListItemText, MenuItem, Select } from "@mui/material";

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth() + 1; // JS months are 0-based

const PeriodFilter = ({
  fromDate,
  toDate,
  yearList,
  setFromDate,
  setToDate,
  setSelectedFacility,
  selectedFacility,
  facilityRequired,
  fixedPeriodMode = false,
  fromFixedLabel = "1st April",
  toFixedLabel = "31st March",
  fromFixedMonth = 4,
  toFixedMonth = 3,
}) => {
  const { user } = useUser();

  const [facilityList, setFacilities] = useState([]);
  const changeMonth = (value, label) => {
    const month = parseInt(value);

    if (label === "From") {
      setFromDate({ ...fromDate, month });

      // Reset "To" date if it becomes invalid
      if (
        toDate.year &&
        (toDate.year < fromDate.year ||
          (toDate.year === fromDate.year && toDate.month < month))
      ) {
        setToDate({ ...toDate, month: "", year: "" });
      }
    } else {
      setToDate({ ...toDate, month });
    }
  };

  const changeYear = (value, label) => {
    const year = parseInt(value);

    if (label === "From") {
      setFromDate({
        ...fromDate,
        year,
        month: fixedPeriodMode ? fromFixedMonth : fromDate.month,
      });

      if (fixedPeriodMode) {
        if (toDate.year && toDate.year <= year) {
          setToDate({ ...toDate, year: "", month: toFixedMonth });
        }
        return;
      }

      // Reset "To" date if it becomes invalid
      if (toDate.year && toDate.year < year) {
        setToDate({ ...toDate, year: "", month: "" });
      } else if (
        toDate.year === year &&
        toDate.month &&
        fromDate.month &&
        toDate.month < fromDate.month
      ) {
        setToDate({ ...toDate, month: "" });
      }
    } else {
      setToDate({
        ...toDate,
        year,
        month: fixedPeriodMode ? toFixedMonth : toDate.month,
      });

      if (fixedPeriodMode) return;

      // Reset "To" month if it becomes invalid
      if (
        toDate.month &&
        fromDate.year === year &&
        fromDate.month &&
        toDate.month < fromDate.month
      ) {
        setToDate({ ...toDate, month: "" });
      }
    }
  };

  const fetchFacilityList = async () => {
    try {
      const res = await get(`/dashboard/scope3/purchasegoods/facilitylist`);
      if (user?.companyAdmin) {
        setFacilities(res?.data?.data);
      }
      console.log(res?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchFacilityList();
  }, []);

  return (
    <div>
      <div className={styles.dates_select}>
        <div className={styles.dates_select}>
          {["From", "To"].map((label) => (
            <div
              key={label}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <p className={styles.dates_heading}>{label}</p>
              <div style={{ display: "flex", gap: "8px" }}>
                {fixedPeriodMode ? (
                  <select
                    value={label === "From" ? fromFixedMonth : toFixedMonth}
                    className={styles.heading_select_month}
                    disabled
                  >
                    <option value={label === "From" ? fromFixedMonth : toFixedMonth}>
                      {label === "From" ? fromFixedLabel : toFixedLabel}
                    </option>
                  </select>
                ) : (
                  <select
                    value={label === "From" ? fromDate.month : toDate.month}
                    onChange={(e) => changeMonth(e.target.value, label)}
                    className={styles.heading_select_month}
                  >
                    <option value="" disabled={true}>
                      Select
                    </option>
                    {monthlist?.map((m) => {
                      const isFrom = label === "From";
                      const selectedYear = isFrom ? fromDate.year : toDate.year;
                      const otherYear = isFrom ? toDate.year : fromDate.year;
                      const otherMonth = isFrom ? toDate.month : fromDate.month;

                      // Disable if month is in the future (beyond current month/year)
                      const isFutureMonth =
                        selectedYear === currentYear && m.id > currentMonth;

                      // For "To" month: disable if it's before "From" month in the same year
                      const isBeforeFromMonth =
                        !isFrom &&
                        selectedYear === otherYear &&
                        otherMonth &&
                        m.id < otherMonth;

                      // For "From" month: disable if it's after "To" month in the same year
                      const isAfterToMonth =
                        isFrom &&
                        selectedYear === otherYear &&
                        otherMonth &&
                        m.id > otherMonth;

                      return (
                        <option
                          key={m.id}
                          value={m.id}
                          disabled={
                            isFutureMonth || isBeforeFromMonth || isAfterToMonth
                          }
                        >
                          {m.month}
                        </option>
                      );
                    })}
                  </select>
                )}

                {/* Year Dropdown */}
                <select
                  value={
                    label === "From" ? fromDate.year || "" : toDate.year || ""
                  }
                  onChange={(e) => changeYear(e.target.value, label)}
                  className={styles.heading_select_year}
                >
                  <option value="" disabled={true}>
                    Select
                  </option>
                  {yearList?.map((y) => {
                    const isFrom = label === "From";
                    const selectedMonth = isFrom ? fromDate.month : toDate.month;
                    const otherYear = isFrom ? toDate.year : fromDate.year;

                    // Disable if year is in the future
                    const isFutureYear = y > currentYear;

                    // Disable if year is current year but already selected month is in the future
                    const isCurrentYearWithFutureMonth =
                      y === currentYear && selectedMonth && selectedMonth > currentMonth;

                    // For "To" year: disable if it's before "From" year
                    const isBeforeFromYear = !isFrom && otherYear && y < otherYear;
                    const isNotAfterFromYear =
                      fixedPeriodMode && !isFrom && otherYear && y <= otherYear;

                    return (
                      <option
                        key={y}
                        value={y}
                        disabled={
                          isFutureYear ||
                          isCurrentYearWithFutureMonth ||
                          isBeforeFromYear ||
                          isNotAfterFromYear
                        }
                      >
                        {y}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          ))}
        </div>
      </div>

      {facilityRequired !== "false" ? (
        <>
          {user?.companyAdmin ? (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignContent: "center",
                marginTop: "1rem",
              }}
            >
              <p className={styles.facility_heading}>Facility </p>

              <Select
                multiple
                displayEmpty
                value={selectedFacility}
                onChange={(e) => setSelectedFacility(e.target.value)}
                renderValue={(selected) =>
                  selected?.length === 0
                    ? "Select Facilities"
                    : facilityList
                        .filter((f) => selected?.includes(f._id))
                        .map((f) => f?.facilityName)
                        .join(", ")
                }
                className={styles.select_facility}
              >
                {facilityList?.map((m) => (
                  <MenuItem key={m?._id} value={m?._id}>
                    <Checkbox checked={selectedFacility?.includes(m?._id)} />
                    <ListItemText primary={m?.facilityName} />
                  </MenuItem>
                ))}
              </Select>
            </div>
          ) : null}
        </>
      ) : null}
    </div>
  );
};

export default PeriodFilter;
